import React, { FC } from 'react';
import styled from 'styled-components';
import { CatalogListSkeleton } from 'src/components/widgets/catalogList';
import {
    SkeletonBlock,
    SkeletonLeftSidebar,
    SkeletonLeftSidebarContent,
    SkeletonLeftSidebarLayout,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonStack
} from 'src/components/widgets/skeleton';

const DraftDesignsSkeletonShell = styled(SkeletonPageShell)``;

const DraftDesignsSkeletonHeader = styled(SkeletonPageHeader)``;

const DraftDesignsSkeletonLayout = styled(SkeletonLeftSidebarLayout)``;

const DraftDesignsSidebarSkeleton = styled(SkeletonLeftSidebar)``;

const DraftDesignsFiltersSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(220px, 1fr) repeat(3, minmax(120px, 180px)) 40px;
    gap: 12px;
    align-items: end;
    min-width: 0;

    @media (max-width: 900px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const DraftDesignsPageSkeleton: FC = () => (
    <DraftDesignsSkeletonShell aria-hidden='true'>
        <DraftDesignsSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(260px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(460px, 100%)' $height='13px' />
            </SkeletonStack>
        </DraftDesignsSkeletonHeader>
        <DraftDesignsSkeletonLayout>
            <DraftDesignsSidebarSkeleton>
                <SkeletonStack $gap='14px'>
                    <SkeletonBlock $width='45%' $height='16px' />
                    <SkeletonBlock $height='36px' $radius='6px' />
                    {Array.from({ length: 7 }).map((_, index) => (
                        <SkeletonStack key={index} $gap='0'>
                            <SkeletonBlock $width={index % 2 === 0 ? '68%' : '52%'} $height='13px' />
                        </SkeletonStack>
                    ))}
                </SkeletonStack>
            </DraftDesignsSidebarSkeleton>
            <SkeletonLeftSidebarContent>
                <CatalogListSkeleton itemsCount={15}>
                    <DraftDesignsFiltersSkeleton>
                        <SkeletonBlock $height='38px' $radius='6px' />
                        <SkeletonBlock $height='38px' $radius='6px' />
                        <SkeletonBlock $height='38px' $radius='6px' />
                        <SkeletonBlock $height='38px' $radius='6px' />
                        <SkeletonBlock $height='38px' $radius='6px' />
                    </DraftDesignsFiltersSkeleton>
                </CatalogListSkeleton>
            </SkeletonLeftSidebarContent>
        </DraftDesignsSkeletonLayout>
    </DraftDesignsSkeletonShell>
);
